import { css } from '@emotion/css';

export const experienceHeaderCss = css`
  position: relative;
`;
